angular.module('bribac.views.add', [
  'ngRoute',
  'bribac.values',
  'bribac.translations',
  'bribac.services.routeAuth'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/add', {
      templateUrl: 'add-view.html',
      controller: 'AddViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('AddViewCtrl', function(
    state,
    ROLES,
    FLAVOUR
  ) {
    var peopleOrGroupsPages = [
      {
        i18n: 'views.add.agent',
        href: '#!/add/agent',
        icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-user'
      },
      {
        i18n: 'views.add.subject',
        href: '#!/add/subject',
        icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-user'
      },
      {
        i18n: 'views.add.group',
        href: '#!/add/group',
        icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-users'
      }
    ];

    // Add insurance-related items only for non-EU instances
    if (FLAVOUR !== 'EU') {
      peopleOrGroupsPages.push(
        {
          i18n: 'views.add.insuranceProvider',
          href: '#!/add/insurance-provider',
          icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-user'
        },
        {
          i18n: 'views.add.insuranceSubscriber',
          href: '#!/add/insurance-subscriber',
          icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-user'
        },
        {
          i18n: 'views.add.insuranceCompany',
          href: '#!/add/insurance-company',
          icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-briefcase'
        }
      );
    }

    peopleOrGroupsPages.push({
      i18n: 'views.upload.subjects',
      href: '#!/upload/subjects',
      icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-upload'
    });

    var groups = [
      {
        i18n: 'views.add.peopleOrGroupsHeading',
        pages: peopleOrGroupsPages
      },
      {
        i18n: 'views.add.planTemplatesHeading',
        pages: [
          {
            i18n: 'views.add.schedule',
            href: '#!/add/schedule',
            icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-calendar'
          },
          {
            i18n: 'views.add.settings',
            href: '#!/add/settings',
            icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-cog'
          }
        ]
      }
    ];

    if (state.currentAgent.roles.indexOf(ROLES.SUPER_ADMIN) > -1) {
      groups.push({
        i18n: 'views.add.organizationsHeading',
        pages: [
          {
            i18n: 'views.add.organization',
            href: '#!/add/organization',
            icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-university'
          },
          {
            i18n: 'views.add.ibac',
            href: '#!/add/ibac',
            icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-cube'
          }
        ]
      });
    }

    this.groups = groups;
  })
